import * as React from 'react'
import styled from 'styled-components'
import logo from '../logo.png'
import logoSmall from '../logo-small.png'

const LogoContainer = styled.div`
  display: flex;
  @media (${({ theme }) => theme.breakPoints.tablet}) {
    flex-direction: column;
  }
`

const LogoImg = styled.img`
  max-height: 76px;
  @media (${({ theme }) => theme.breakPoints.tablet}) {
    display: none;
  }
`

LogoImg.displayName = 'LogoImg'

const LogoSmallImg = styled.img`
  height: 100%;
  display: none;
  @media (${({ theme }) => theme.breakPoints.tablet}) {
    display: block;
    height: 48px;
  }
`

LogoSmallImg.displayName = 'LogoSmallImg'

const Logos = styled.div`
  display: flex;
  justify-content: center;
`

const DescriptorContainer = styled.div`
  display: block;
  align-self: center;
  color: ${({ theme }) => theme.palette.nswBrandDark};
  padding-left: 2.75rem;
  line-height: 1.75rem;

  @media screen and (${({ theme }) => theme.breakPoints.tablet}) {
    display: none;
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
    padding-left: 0;
    align-self: flex-start;
  }
`
DescriptorContainer.displayName = 'DescriptorContainer'

const PrimaryDescriptor = styled.div`
  font-weight: 700;
  font-size: ${({ theme }) => theme.font.heading};
`

const SecondaryDescriptor = styled.div`
  font-size: calc(${({ theme }) => theme.font.heading} * 0.7);
`

type Descriptors = {
  primary: string
  secondary: string
}

export function FormsAppLogo({ descriptors }: { descriptors: Descriptors }) {
  return (
    <LogoContainer>
      <Logos>
        <LogoImg src={logo} alt="Logo" />
        <LogoSmallImg src={logoSmall} alt="Logo" />
      </Logos>
      <DescriptorContainer>
        <PrimaryDescriptor>{descriptors.primary}</PrimaryDescriptor>
        {descriptors.primary && (
          <SecondaryDescriptor>{descriptors.secondary}</SecondaryDescriptor>
        )}
      </DescriptorContainer>
    </LogoContainer>
  )
}
